import { useRef, useState } from 'react';

import type { RequestScrollCallback } from '@chewy/chat-library-common';

/**
 * Time in millseconds to pause after scrolling to selected card before
 * scrolling to next user message
 */
const SCROLL_PAUSE_MS = 1000;

export const useCardSelector = ({
  requestScroll
}: {
  requestScroll: RequestScrollCallback | undefined
}) => {
  const itemRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const [hideUnselected, setHideUnselected] = useState(false);

  // When all scrolling has completed, show the hidden cards again after
  // 500ms
  const handleScrollAllComplete = () => {
    setTimeout(() => {
      setHideUnselected(false);
    }, 500);
  };

  const handleSelect = (index: number, messageTimestamp: string) => {
    const el = itemRefs.current[index];

    if (el) {
      setHideUnselected(true);
      if (requestScroll) {
        requestScroll({
          element: el,
          timestamp: messageTimestamp,
          priority: 1,
          timeout: SCROLL_PAUSE_MS,
          onScrollAllComplete: handleScrollAllComplete,
        });
      } else {
        handleScrollAllComplete();
      }
    }
  }

  return { hideUnselected, handleSelect, itemRefs };
}
